import _ from "lodash";
import defaultAppConfig from "../defaultAppConfig.json";
import defaultSummaryConfig from "../defaultSummaryConfig.json";
import client, { configuration } from "../api/client/SdsWebApiClient";
import { SummaryConfig, Convert } from "../models/summaryConfig";

const getAppConfig = async (path: string | undefined | null = null): Promise<any> => {
    if (!path) return defaultAppConfig;
    const response = await fetch(path, { cache: "no-cache" });
    const config = await response.json();
    const mergeConfigs = _.merge(defaultAppConfig, config);
    return mergeConfigs;
};

const getSummaryData = async (path: string | undefined | null = null): Promise<SummaryConfig> => {
    if (!path) return Convert.toSummaryConfig(JSON.stringify(defaultSummaryConfig));
    const response = await fetch(path, { cache: "no-cache" });
    const config = await response.json();

    return Convert.toSummaryConfig(JSON.stringify(config || defaultSummaryConfig));
};

export const loadConfigurationFiles = async (language: string): Promise<[Object, SummaryConfig]> => {
    const configurationFilesUrls = await client.getConfigurationFilesGet(language);
    return Promise.all([
        getAppConfig(configurationFilesUrls.stylingFile),
        getSummaryData(configurationFilesUrls.summaryFile),
    ]);
};

export const getFrontendSettings = async () => {
    const response = await fetch(`${configuration.basePath}/frontend_settings.json`, { cache: "no-cache" });
    const settings = await response.json();

    return settings;
};
